module.exports = __webpack_public_path__ + "img/xgs_logo.84888ecf.png";